import { Link } from "react-router-dom";
import type { Show } from "@/mocks/tv/shows";
import ShowCard from "@/components/base/ShowCard";

interface ShowSectionProps {
  id?: string;
  eyebrow?: string;
  title: string;
  desc?: string;
  shows: Show[];
  viewAllHref?: string;
  viewAllLabel?: string;
  gridClassName?: string;
}

export default function ShowSection({
  id,
  eyebrow,
  title,
  desc,
  shows,
  viewAllHref,
  viewAllLabel = "查看更多",
  gridClassName = "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5",
}: ShowSectionProps) {
  return (
    <section id={id} className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
        <div>
          {eyebrow && (
            <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-600 uppercase tracking-widest mb-2">
              <span className="w-6 h-1 flex items-center justify-center">
                <span className="block w-6 h-1 rounded-full bg-accent-500" />
              </span>
              {eyebrow}
            </span>
          )}
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">{title}</h2>
          {desc && <p className="mt-2 text-sm text-foreground-500 max-w-2xl">{desc}</p>}
        </div>
        {viewAllHref && (
          <Link
            to={viewAllHref}
            className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap shrink-0"
          >
            {viewAllLabel}
            <i className="ri-arrow-right-s-line text-lg w-5 h-5 flex items-center justify-center" />
          </Link>
        )}
      </div>

      <div className={gridClassName}>
        {shows.map((show) => (
          <ShowCard key={show.id} show={show} />
        ))}
      </div>
    </section>
  );
}